export default __webpack_public_path__ + "static/wsl-grafana-login-2afe004b2222af8de44638062f8e1801.webp";